import React, { useState } from 'react';
import { Box, Paper } from '@mui/material';
import StoneForm from '../components/stone/StoneForm';
import StoneTable from '../components/stone/StoneTable';

const StonePage = () => {
  const [selectedStone, setSelectedStone] = useState(null);

  const handleEdit = (stone) => {
    setSelectedStone(stone);
  };

  const handleFormReset = () => {
    setSelectedStone(null);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'flex-start',
        width: '100%',
        flexWrap: { xs: 'wrap', md: 'nowrap' }, 
        p: 2,
      }}
    >
      {/* Table - Left Side */}
      <Paper
        elevation={3}
        sx={{
          flex: 2,
          p: 2,
          minWidth: 0,
        }}
      >
        <StoneTable onEdit={handleEdit} />
      </Paper>

      {/* Form - Right Side */}
      <Paper
        elevation={3}
        sx={{
          flex: 1,
          p: 2,
          minWidth: 300,
        }}
      >
        <StoneForm
          selectedStone={selectedStone}
          onReset={handleFormReset}
        />
      </Paper>
    </Box>
  );
};

export default StonePage;
